module.exports = __webpack_public_path__ + "img/4_3_1.132025e2.jpg";